import { render, staticRenderFns } from "./ImageExample.vue?vue&type=template&id=1a44070c&scoped=true"
import script from "./ImageExample.vue?vue&type=script&lang=js"
export * from "./ImageExample.vue?vue&type=script&lang=js"
import style0 from "./ImageExample.vue?vue&type=style&index=0&id=1a44070c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a44070c",
  null
  
)

export default component.exports